// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3225":"e78b34b7","4254":"56c12eb5","6855":"47bf8baf","7611":"79f774c5"}[chunkId] || chunkId) + "." + {"1488":"98ec30eaf0a5ea4f","2880":"ef2e692663d1cd0c","3225":"048c1ec9dc9b5dab","4254":"cfaf0f642ce9413b","6855":"e3f09b5e71ecc7e7","7611":"1dc9e839634ae9d1"}[chunkId] + ".js";
};